import styled from 'styled-components';

export const TrashButton = styled.button`
	width: 1px;
	margin-left: auto;
`;

export const RemoveWorkflowArea = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: end;
`;
